<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
	<footer class="footer noprint" :style="{ marginTop: footerTopMargin, height: showFloatingFooterBlock ? '60px': null }">
		<div v-if="!isMobile" class="container">
			<div style="display: grid; grid-template-columns: auto 1fr;">
				<div class="footer-block">
					<div>
						<template v-if="languagesSupported.length > 1 && !loggedIn">
							<font-awesome-icon icon="globe-europe" class="mr-2" />

							<a v-for="language in languagesSupported" :key="language.key" :href="'/' + language.key" :class="{'language-active': currentLanguage == language.key}" class="language-switch mr-2" @click.stop.prevent="switchLanguage(language.key)">{{ language.name }}</a>
						</template>

						<span class="ml-3">{{ t.copyright }}</span>
					</div>
				</div>

				<div class="footer-block">
					<div class="text-right">
						<!-- Footer menu -->
						<!-- combined to one string to avoid unexpected spaces (artefacts) between items  -->
						<router-link v-if="settings.newsEnabled" :to="{name: 'news', params: {language: currentLanguage}}" class="ml-2">{{ t.mainMenuNews }}</router-link><router-link v-for="item in menuItems" :key="item.name" :to="{name: item.name, params: {language: currentLanguage}}" class="ml-2">{{ item.title }}</router-link>

						<span v-if="showSocialIcons" class="social-icons">
							<div v-if="settings.facebookUrl">
								<a :href="settings.facebookUrl" target="_blank">
									<font-awesome-icon :icon="['fab', 'facebook-f']" />
								</a>
							</div>
							<div v-if="settings.youtubeUrl">
								<a :href="settings.youtubeUrl" target="_blank">
									<font-awesome-icon :icon="['fab', 'youtube']" />
								</a>
							</div>
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Mobile sticky footer if user is not connected -->
		<div v-if="showFloatingFooterBlock" class="footer-mobile-fixed-block">
			<button class="btn-primary" @click="$router.push({name: 'sign-in' })">
				{{ t.loginButton }}
			</button>
		</div>
	</footer>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { includes } from "lodash-es";
import { switchLanguage } from '../classes/translations';
import { useStore } from '@/js/stores/index';
import { useUserStore } from '../stores/user';

const store = useStore()
const userStore = useUserStore()
const route = useRoute()

// Computeds
const t = computed(() => store.translations)
const loggedIn = computed(() => userStore.loggedIn)
const currentLanguage = computed(() => store.currentLanguage)
const showSocialIcons = computed(() => settings.value.facebookUrl || settings.value.youtubeUrl)
const settings = computed(() => store.settings)
const languagesSupported = computed(() => store.settings.languagesSupported)
const menuItems = computed(() => store.menuItems)
const isMobile = computed(() => store.isMobile)
const footerTopMargin = computed(() => (route.matched[1] && route.matched[1].name == "monthly-top-user") ? '0px' : null)
const showFloatingFooterBlock = computed(() => {
	return isMobile.value && showSignInButton.value
})

const showSignInButton = computed(() => {
	return !loggedIn.value && includes([
		"monthly-top-user",
		"business",
		"news",
		"news-item",
		"terms",
		"help",
		"about",
		"privacy-policy"
	], route.name)
})
</script>
